import { FC } from 'react';
import { Flex, FlexProps, Switch, SwitchProps } from '@mantine/core';

import { useFormComponentContext } from 'context/FormContext';
import useEditStyles from 'hooks/useEditStyles';

interface FormSwitchProps extends Omit<SwitchProps, 'onChange' | 'children'> {
  name: string;
  label?: string;
  error?: string;
  required?: boolean;
  showEdit?: boolean;
  description?: string;
  containerProps?: FlexProps;
  onChange?: (value: boolean) => void;
  allowFormChange?: boolean;
}

const FormSwitch: FC<FormSwitchProps> = ({
  name,
  label,
  onChange,
  required,
  description,
  containerProps,
  allowFormChange = true,
  showEdit = false,
  ...props
}) => {
  const form = useFormComponentContext();
  const { editedSwitchStyles } = useEditStyles({ name, showEdit });

  return (
    <Flex align="center" gap="sm" {...containerProps}>
      <Switch
        label={label}
        required={required}
        styles={{ ...editedSwitchStyles, ...props.styles }}
        {...form.getInputProps(name)}
        {...props}
        checked={form.getInputProps(name).value}
        onChange={(event) => {
          const value = event.target.checked;
          allowFormChange && form.getInputProps(name).onChange(event);
          onChange?.(value);
        }}
        // TODO: Implement custom Switch styling configuration
        // The following styles would customize the track and thumb appearance for better brand consistency
        // Currently disabled pending design system finalization
        // 
        // styles={{
        //   track: {
        //     borderRadius: '4px',
        //   },
        //   thumb: {
        //     width: '0.9rem',
        //     borderRadius: '2px',
        //   },
        // }}
      />
    </Flex>
  );
};

export default FormSwitch;
